angular.module("dx.webapp.results", [
	"dx.webapp.exam",
	"dx.webapp.examParts",
	"dx.webapp.question",
	"dx.webapp.accessibility",
	"dx.webapp.roles",
	"digiexam.exam",
	"digiexam.services",

	"dx.ui.dataTypes.grading",
	"dx.ui.dataTypes.question",
]);
